import { AfterViewChecked, Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgModel, ReactiveFormsModule, ValidationErrors, Validator } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { CustomFieldTextComponent, CustomFieldCheckboxComponent,  } from './fields/fields'
import { CustomFieldTextareaComponent } from "./fields/components/textarea/textarea.component";
import { CustomFieldNumericComponent } from "./fields/components/numeric/numeric.component";
import { CustomFieldNif } from "./fields/components/nif/nif.component";
import { CustomFieldIbanComponent } from "./fields/components/iban/iban.component";
import { CustomFieldCalendarComponent } from "./fields/components/calendar/calendar.component";
import { CustomFieldDropdownComponent } from "./fields/components/dropdown/dropdown.component";
import { CustomFieldFileComponent } from "./fields/components/file/file.component";
import { CustomFieldPhoneComponent } from "./fields/components/phone/phone.component";
import { CustomFieldEmailComponent } from "./fields/components/email/email.component";
import { CustomFieldsConstants } from 'src/app/constants/CustomFieldsConstants';
import { CustomFieldDTO } from 'src/app/DTO/CustomFieldDTO';
import { NiaInput } from '../nia-input/nia-input.component';
import { CustomFieldMultiselectComponent } from './fields/components/multiselect/multiselect.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-custom-field-input',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomFieldInputComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CustomFieldInputComponent),
      multi: true
    }
  ],
  templateUrl: './custom-field-input.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomFieldCheckboxComponent,
    CustomFieldTextComponent,
    CustomFieldTextareaComponent,
    CustomFieldNumericComponent,
    CustomFieldNif,
    CustomFieldIbanComponent,
    CustomFieldCalendarComponent,
    CustomFieldDropdownComponent,
    CustomFieldFileComponent,
    CustomFieldPhoneComponent,
    CustomFieldEmailComponent,
    NiaInput,
    CustomFieldMultiselectComponent
],
  styleUrls: ['./custom-field-input.component.scss']
})
export class CustomFieldInputComponent implements OnInit, AfterViewChecked, OnDestroy, ControlValueAccessor, Validator{

  @ViewChild('input') input!: NgModel;

  @Input()
  public customField: CustomFieldDTO | null;
  @Input()
  public type: string;

  @Input()
  public readonly: boolean;

  public internalValue: any;
  public show = false;
  public oldValue: string;
  public InputTypes = CustomFieldsConstants.InputTypes;
  public DropdownTypes = CustomFieldsConstants.DropdownTypes;

  @Output() priceChanged = new EventEmitter<any>();
  onChange: (_: string) => void = (_: string) => { };
  private onValidatorChange: () => void = () => {};
  private statusSub?: Subscription;

  constructor() { }

  ngOnInit(): void { }

  ngAfterViewChecked(): void {
    this.ensureStatusSubscription();
  }

  ngOnDestroy(): void {
    this.statusSub?.unsubscribe();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void { }

  writeValue(val: string): void {
    this.internalValue = val;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const value = (control?.value ?? null) as unknown;
    // Required
    if (!this.readonly && this.customField.required && (value === null || ((typeof value === 'string' || Array.isArray(value)) && value.length === 0))) {
      return {
        required: true
      }
    }

    // Any errors
    if(this.input) {
      return this.input.control.errors;
    }

    return null;
  }

  registerOnValidatorChange?(fn: () => void): void {
    this.onValidatorChange = fn;
    this.ensureStatusSubscription();
  }

  private ensureStatusSubscription(): void {
    if (!this.onValidatorChange) return;
    if (!this.input?.statusChanges) return;
    if (this.statusSub) return;

    this.statusSub = this.input.statusChanges.subscribe(() => this.onValidatorChange());
  }

  updateChanges(value: string) {
    if (this.customField) {
      this.customField.value = value;
      this.onChange(this.customField.value);
    }


    if (
        (this.customField?.type === this.InputTypes.DROPDOWN || this.customField?.type === this.InputTypes.MULTISELECT)
        && this.customField?.dropdownType === this.DropdownTypes.TABLE
    ) {
      this.priceChanged.emit();
    }
  }
}
